<template>
  <Modal
      height="677px"
      width="912px"
      @close="$emit('close')"
  >
    <h2 style="margin-bottom: 24px">Журнал билетов</h2>
    <div
        class="scroll"
        ref="scroll"
    >
      <VTable
          itemsType="array"
          :columns="headers"
          :items="tickets"
          ref="table"
          isHistory
      >
      </VTable>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import VTable from "@/components/Table/VTable.vue";
import PageOptions from "@/models/PageOptions";

export default {
  name: "HistoryTickets",
  components: {
    Modal,
    VTable,
  },
  props: [
    'ticket'
  ],
  data: function () {
    return {
      firstLoading: true,
      pageOptions: new PageOptions(),
      nextPageLoading: false,
      allPageLoaded: false,
      headers: [
        {title: "Маршрут", sort: false, value: "path"},
        {title: "Статья расходов", sort: false, value: "expenses"},
        {title: "Вид транспорта", sort: false, value: "transport"},
        {title: "№ рейса", sort: false, value: "number_flight"},
        {title: "№ билета", sort: false, value: "number_ticket"},
        {title: "Стоимость билет", sort: false, value: "price"},
        {title: "НДС", sort: false, value: "tax"},
        {title: "Сумма штрафа", sort: false, value: "penalty"},
        {title: "Дата отправления", sort: false, value: "start_date"},
        {title: "Дата прибытия", sort: false, value: "finish_date"},
        {title: "Дата возврата", sort: false, value: "return_date"},
        {title: "ФИО", sort: false, value: "user"}
      ],
      tickets: []
    };
  },
  computed: {},
  mounted() {
    this.ticket.map((el) => {
      if (el.history) {
        const ticketHistory = JSON.parse(el.history)
        let date = new Date(ticketHistory.return_date)
        ticketHistory.return_date = date.toLocaleString().replace(',', ' ').substr(0, 17)
        delete ticketHistory.comment
        this.tickets.push(ticketHistory)
      } else {
        this.tickets.push(el)
      }
    })
  },
  methods: {}
};
</script>

<style scoped lang="scss"></style>
